<script lang="ts" setup>
import { ref } from 'vue';
import { MEDIUM_LIST } from '@@summit/2023/constants'
import SliceImage from '@@summit/2023/components/SliceImage.vue';

defineOptions({
  name: 'PageHomeMedium',
});

const mediumList = ref(MEDIUM_LIST);
</script>

<template>
  <section class="page-home-medium">
    <h2 class="mt-[128px]">媒体合作</h2>
    <p>MEDIUM</p>
    <div class="">
      <div class="card" v-for="(item, index) in mediumList" :key="index">
        <h3 class="mt-32px">
          {{ item.title }}
        </h3>
        <div class="flex-start mt-[16px] flex flex-wrap">
          <SliceImage class="mt-8px" :url="item.image" width="200" height="72" v-slot="{ image }" v-if="item.image">
            <div class="h-[72px] w-[200px]">
              <img :src="image" class="card-img" alt="">
            </div>
          </SliceImage>
          <div v-for="(item1, index1) in item.content" :key="index1" v-else>
            <div class="h-[72px] w-[200px]">
              <img :data-src="item1" class="card-img lazyload" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-home-medium {
  width: 1200px;
  margin: 0 auto;

  h2 {
    color: #00479d;
    font-weight: 500;
    font-size: 32px;
    line-height: 45px;
  }

  p {
    color: #00479d;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .card-img {
    width: 100%;
    height: 100%;
  }

  h3 {
    color: #00479d;
    font-weight: 400;
    font-size: 24px;
    line-height: 33px;
  }
}
</style>
